/* eslint-disable import/no-cycle */
import { FormFieldActionEvent } from '@/models'
import TrackingModule from '@/store/modules/tracking'

async function handleTrackingEvent(event: FormFieldActionEvent): Promise<unknown> {
  return TrackingModule.postFormFieldAction(event)
}

export default handleTrackingEvent
